<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>海關研學</el-breadcrumb-item>
                <el-breadcrumb-item>創作投稿</el-breadcrumb-item>
                <el-breadcrumb-item>我的創作</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



    <div class="content">
      <div class="left-content">
        <div class="left-content-box">
          <el-menu
            mode="vertical"
            @select="handleSelect"
          >
            <el-menu-item class="left-tab" index="1"  @click="leftbtn(1)">
              <span>中心首頁</span>
            </el-menu-item>

            <el-menu-item class="left-tab" index="0"  @click="leftbtn(0)">
              <span>對比研究</span>
            </el-menu-item>
            
            <el-menu-item class="left-tab" index="2" @click="leftbtn(2)">
              <span>
                創作投稿
              </span>
              </el-menu-item>

            <el-menu-item class="left-tab1" index="3" @click="leftbtn(3)">
              <span>
                我的創作
              </span>
              </el-menu-item>

            <el-menu-item class="left-tab1" index="4" @click="leftbtn(4)">
              <span>
                投稿通道
              </span>
              </el-menu-item>
          </el-menu>
          
        </div>
        
      </div>

      <div v-if="activeIndex==3" class="right-content">

        <div class="row1">
          <div class="row1-btns">
            <div class="btn-dr">
              <div>導入</div>
            </div>
            <div @click="new_cz" class="btn-xj">
              <div>新建</div>
            </div>
          </div>
        </div>

        <div class="row2">



          <template>
                <div style="min-height:500px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"

                  style="margin-left:20px; width: 980px;">
                  <el-table-column
                    prop="gxsd_pubulish_serial"
                    label="序號"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_pubulish_serial"
                    label="名稱"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_chinese_title"
                    label="類型"
                    width="350">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_date_time"
                    label="編輯時間"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_port_name"
                    label="操作"
                    width="150">
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:980px">
                  <div style="text-align: right;margin-top: 30px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

              </template>
        </div>
      </div>



      <div v-if="activeIndex==4" class="right-content">
        <div v-for="mag in magzimelist" :key="mag">

          <div class="tg-row">
          <div class="book-img">
            <img style="width:150px;height:210px;" :src="sourceurl+mag.front_img_url" alt="">
          </div>
          <div class="book-info">
            <div class="book-name">
              <div >{{mag.magzine_name}}</div>
            </div>
            <div class="book-type" >
              <div ><li>{{mag.type}}</li></div>
            </div>
            <div class="fhyz">
              <div>（2019版）復合影響因子:</div><div>{{mag.fhyz}}</div>
            </div>
            <div class="zhyz">
              <div>（2019版）綜合影響因子:</div><div>{{mag.zhyz}}</div>
            </div>
            <div class="qkry">
              <div>期刊榮譽：</div><div>{{mag.qkry}}</div>
            </div>
          </div>
          <div class="wytg">
            <el-button class="wytg-btn" >我要投稿</el-button>
          </div>
        </div>

        </div>

        

        
        

      </div>
      


        
    </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
      //totaldata:'99999',
      activeIndex:this.$route.query.aIndex,
      magzimelist:'',
      searchtxt:'',
      sourceurl:'',
      
    };
  },
  methods: {
    
    leftbtn(a){
      //this.sclass=a;
      //this.submitform();
      this.activeIndex=a;
      if(this.activeIndex==0){
        //对比

      }
      if(this.activeIndex>1){
        //创作
        this.$router.push({ path: "/hgresearch_cz",query:{aIndex:this.activeIndex}});
      }
    },
    new_cz(){
      this.$router.push({path:"/hgresearch_new"});
    }
  },
  created() {
    this.sourceurl=`${this.$store.state.sourceurl}../..`;
    this.$http
      .get(`${this.$store.state.baseurl}/api/hgresearch_cz/getmagzimedata?searchtxt=`+this.searchtxt)
      .then((res) => {
        const json = res.data;
        let pinfo=JSON.parse(json);
        this.magzimelist=pinfo.data;
        
      });
    
  },
};
</script>



<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .left-content{
    width:180px;
    min-height:600px;
    font-size: 16px;
    border-width: 0px 1px 0px 0px ;
	  border-style: solid;
	  border-color:#cec0b2;
    .left-content-box{

        margin-top: 16px;
        .left-tab :hover{
          background-color:#e5e2db !important ;
          color: #666666;
          font-weight: 550;
          font-size: 16px;

        }
        .left-tab{
          border-width: 0px 1px 0px 0px ;
          font-weight: 550;
          text-align: left;
          background: none;
          font-size: 16px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }


        .left-tab1 :hover{
          background-color:#e5e2db !important ;
          color: #666666;
          font-weight: 400;
          font-size: 14px;

        }
        .left-tab1{
          
          border-width: 0px 1px 0px 0px ;
          font-weight: 400;
          text-align: center;
          background: none;
          font-size: 14px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }
        
        div{
        padding:16px ;
        a{
          text-decoration: none;
        }
      }
      

    }
    
  }
  .right-content{
    width: 1000px;
    .tg-row{
      margin-top: 30px;
      margin-left: 30px;
      padding-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      border-block-end: 1px dashed  #ddd;
      .book-img{
        width:180px;
        height: 210px;
      }
      .book-info{
        padding-left: 25px;
        width: 620px;
        .book-name{
          margin-top: 10px ;
          margin-bottom: 10px;
          text-align: left;
          color: #333333;
          font-size: 20px;
          font-weight: 500;

        }
        .book-type{
          display: flex;
          flex-direction: row;
          justify-content: start;
          flex-wrap: wrap;
          margin-top: 15px;
          margin-bottom: 30px;
          div{
            margin-left: 15px;
            margin-right: 15px;
              li{
              color: #906442;
              font-size: 14px;
            }
          } 
        }
        .fhyz{
          display: flex;
          flex-direction: row;
          justify-content: start;
          flex-wrap: wrap;
          color: #666666;
          margin-bottom: 6px;
        }
        .zhyz{
          display: flex;
          flex-direction: row;
          justify-content: start;
          flex-wrap: wrap;
          color: #666666;
          margin-bottom: 6px;
        }
        .qkry{
          display: flex;
          flex-direction: row;
          justify-content: start;
          flex-wrap: wrap;
          color: #666666;
          margin-bottom: 6px;
        }
      }
      .wytg{
        padding-top: 80px;
        .wytg-btn{
          width: 120px;
          height: 40px;
          color: #ffffff;
          background-color: #c60828 ;
        }
      }
    }

    .row1{
      .row1-btns{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        margin-top: 20px;
        margin-bottom: 8px;
        margin-left: 810px;
        .btn-dr{
          width:80px;
          height: 35px;
          border-radius: 5px;
          background-color: #c60828;
          border:1px solid #c60828;
          color: #ffffff;
          font-size: 14px;
          div{
           margin: 8px 20px;
          }
        }
        .btn-xj{
          margin-left: 20px;
          width:80px;
          height: 35px;
          color: #c60828;
          border:1px solid #c60828;
          border-radius: 5px;
          div{
           margin: 8px 20px;
          }
        }
      }
    }
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.row2{
  width:1000px;
  margin-bottom: 15px;
}




</style>